

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const DELETEPDFBYNAME= createAsyncThunk(
  "deletePdfByName/deletePdfByName",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const deletePdfByNameSlice = createSlice({
  name: "deletePdfByNameSlice",
  initialState: {
    deletePdfByName: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdeletePdfByName: (state) => {
        state.deletePdfByName.loading = false
        state.deletePdfByName.error = false
        state.deletePdfByName.data = []
        state.deletePdfByName.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DELETEPDFBYNAME.fulfilled, (state, action) => {
      state.deletePdfByName = {
        ...state.deletePdfByName,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEPDFBYNAME.pending, (state, action) => {
      state.deletePdfByName = {
        ...state.deletePdfByName,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETEPDFBYNAME.rejected, (state, action) => {
      state.deletePdfByName = {
        ...state.deletePdfByName,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const deletePdfByNameAction = {
    DELETEPDFBYNAME,
};

export { deletePdfByNameAction };
export default deletePdfByNameSlice.reducer;
export const {setInitialStateOfdeletePdfByName} = deletePdfByNameSlice.actions
